var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"primary--text text-h2 text-md-h1 overflow-hidden"},[_c('span',{staticClass:"d-inline-block position-relative title-widget",class:{ 'title-widget-bottom': _vm.bottom }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }